// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1Kz48","active":"downloadDropdown_active__2b5ja"};